import React from "react";
import { Link } from "react-router-dom";

const TOKEN =
  /(https?:\/\/[^\s]+|careers\.qiktruck\.co\.za\/[^\s]+)/gi;

function splitTrailingPunct(token) {
  const match = token.match(/^(.*?)([.,;:!?)]*)$/);
  return {
    core: match?.[1] || token,
    punct: match?.[2] || "",
  };
}

function toHref(core) {
  if (/^https?:\/\//i.test(core)) return core;
  return `https://${core}`;
}

function internalPath(href) {
  try {
    const url = new URL(href);
    if (url.hostname !== "careers.qiktruck.co.za") return null;
    return `${url.pathname}${url.search}${url.hash}` || "/";
  } catch {
    return null;
  }
}

/** Turn bare careers URLs and https links in legal copy into clickable anchors. */
export function linkifyLegalText(text) {
  const value = String(text || "");
  const parts = value.split(TOKEN);
  if (parts.length === 1) return value;

  return parts.map((part, index) => {
    if (!part) return part;
    TOKEN.lastIndex = 0;
    if (!TOKEN.test(part)) {
      TOKEN.lastIndex = 0;
      return part;
    }
    TOKEN.lastIndex = 0;
    const { core, punct } = splitTrailingPunct(part);
    const href = toHref(core);
    const path = internalPath(href);
    if (path) {
      return (
        <React.Fragment key={`${index}-${core}`}>
          <Link to={path}>{core}</Link>
          {punct}
        </React.Fragment>
      );
    }
    return (
      <React.Fragment key={`${index}-${core}`}>
        <a href={href} target="_blank" rel="noopener noreferrer">
          {core}
        </a>
        {punct}
      </React.Fragment>
    );
  });
}
